import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { RiEdit2Fill } from 'react-icons/ri';
import { Config } from '../../types/configurations';
import { showTimeIn12HrsFormat } from '../../utils/timeAndDate';
import SkillBadge from '../CommonComps/Badges/SkillBadge';
import UpdateAssociateConfigModal from '../CommonComps/Modals/UpdateAssociateConfigModal';

const ProfileConfigRow = ({ config }: { config: Config }) => {
  // destructuring the config object here
  const {
    service_data,
    lead_time,
    finish_time,
    slot_duration,
    appointment_buffer_time,
    reschedule_limit,
    working_days_with_names,
  } = config || {};

  // integration of react hooks here
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // rendering profile config table row component here
  return (
    <>
      <div className='w-fit md:w-full grid grid-cols-profile-config-table text-center text-base-dark-blue border-b border-dashed border-base-dark-blue [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-base-dark-blue [&>div]:p-2'>
        <div
          title={service_data.name}
          className='flex items-center justify-center'
        >
          <p className='w-full truncate'>{service_data.name}</p>
        </div>

        <div
          title={`${showTimeIn12HrsFormat(lead_time)} - ${showTimeIn12HrsFormat(
            finish_time
          )}`}
          className='flex items-center justify-center'
        >
          <p className='w-full truncate'>
            {showTimeIn12HrsFormat(lead_time)} -{' '}
            {showTimeIn12HrsFormat(finish_time)}
          </p>
        </div>

        <div
          title={slot_duration.toString()}
          className='flex items-center justify-center'
        >
          <p className='w-full truncate'>{slot_duration}</p>
        </div>

        <div
          title={appointment_buffer_time.toString()}
          className='flex items-center justify-center'
        >
          <p className='w-full truncate'>{appointment_buffer_time}</p>
        </div>

        <div
          title={reschedule_limit.toString()}
          className='flex items-center justify-center'
        >
          <p className='w-full truncate'>{reschedule_limit}</p>
        </div>

        <div className='flex items-center justify-center gap-1 flex-wrap'>
          {working_days_with_names.map((day) => (
            <SkillBadge key={day.value} badgeLabel={day.day} color='#388229' />
          ))}
        </div>

        <div className='flex items-center justify-center'>
          <button
            title='Edit Provided Services'
            onClick={() => setShowEditModal((state) => !state)}
            className='text-base-white bg-base-cyan border border-base-cyan p-1 rounded-md hover:opacity-70 active:scale-95 duration-300'
          >
            <RiEdit2Fill className='size-5' />
          </button>
        </div>
      </div>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showEditModal ? (
          <UpdateAssociateConfigModal
            config={config}
            handleModalClose={() => setShowEditModal(false)}
          />
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default ProfileConfigRow;
